import { Component } from "react";
import { GiraffeLoader as HuiGiraffeLoader } from "hireart-components";

class GiraffeLoader extends Component {
  render() {
    return <HuiGiraffeLoader />;
  }
}

export default GiraffeLoader;
